export default __webpack_public_path__ + "static/media/instagram.356d995f.png";